(function () {
  "use strict";

  var BODY_OPEN_CLASS = "mobile-menu-open";
  var BODY_OPENING_CLASS = "dyz-mobile-menu-opening";
  var BODY_SUBPANEL_CLASS = "dyz-mobile-subpanel-open";
  var BODY_CLOSING_CLASS = "dyz-mobile-menu-closing";
  var DRAWER_OPENING_CLASS = "dyz-drawer-opening";
  var DRAWER_CLOSING_CLASS = "dyz-drawer-closing";
  var DRAWER_OPEN_ANIMATION_MS = 560;
  var DRAWER_CLOSE_ANIMATION_MS = 380;
  var drawerAnimationTimer = null;
  var preloadedMegaProductsCache = null;
  var dragState = null;
  var dragEventsEnabled = false;
  var DRAG_MOVE_OPTIONS = { passive: false };

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function cleanText(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function isDirectCollectionSubmenuLink(link) {
    if (!link) return false;

    var title = cleanText(link.textContent).toLowerCase();

    return title === "all backsplash tiles";
  }

  function isValidNavigableHref(href) {
    if (!href) return false;

    href = String(href).trim();

    if (!href) return false;
    if (href === "#") return false;
    if (href.toLowerCase() === "javascript:void(0)") return false;
    if (href.toLowerCase() === "javascript:;") return false;
    if (href.toLowerCase().indexOf("javascript:") === 0) return false;

    return true;
  }

  function navigateToHref(href) {
    if (!isValidNavigableHref(href)) return false;

    window.location.href = href;
    return true;
  }

  function getEventClientX(event) {
    if (event && typeof event.clientX === "number") return event.clientX;

    if (event && event.touches && event.touches[0] && typeof event.touches[0].clientX === "number") {
      return event.touches[0].clientX;
    }

    if (event && event.changedTouches && event.changedTouches[0] && typeof event.changedTouches[0].clientX === "number") {
      return event.changedTouches[0].clientX;
    }

    return null;
  }

  function isSubmenuArrowAreaClick(event, link) {
    if (!event || !link || !link.getBoundingClientRect) return false;

    var clientX = getEventClientX(event);
    if (clientX === null) return false;

    var rect = link.getBoundingClientRect();
    if (!rect || rect.width <= 0) return false;

    var buttonSize = getCustomPxValue("--dyz-mobile-menu-expand-button-size", 42);
    var arrowAreaWidth = Math.max(56, Math.min(86, buttonSize + 32));
    var direction = window.getComputedStyle(link).direction;

    if (direction === "rtl") {
      return clientX <= rect.left + arrowAreaWidth;
    }

    return clientX >= rect.right - arrowAreaWidth;
  }

  function ensureDirectCollectionLinkStyle() {
    if (document.getElementById("dyz-direct-collection-link-style")) return;

    var style = document.createElement("style");
    style.id = "dyz-direct-collection-link-style";
    style.textContent = [
      "body.mobile-menu-open .offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link,",
      ".offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link {",
      "  padding-right: 24px !important;",
      "}",
      "body.mobile-menu-open .offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link::before,",
      "body.mobile-menu-open .offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link::after,",
      ".offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link::before,",
      ".offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link::after {",
      "  content: none !important;",
      "  display: none !important;",
      "  opacity: 0 !important;",
      "  visibility: hidden !important;",
      "  background: transparent !important;",
      "  border: 0 !important;",
      "}",
      "body.mobile-menu-open .offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link:hover::before,",
      "body.mobile-menu-open .offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link:hover::after,",
      "body.mobile-menu-open .offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link:focus::before,",
      "body.mobile-menu-open .offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link:focus::after,",
      "body.mobile-menu-open .offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link:active::before,",
      "body.mobile-menu-open .offcanvas-header .offcanvas__sub_menu_item.dyz-direct-collection-link:active::after {",
      "  content: none !important;",
      "  display: none !important;",
      "  opacity: 0 !important;",
      "  visibility: hidden !important;",
      "}",
    ].join("\n");

    document.head.appendChild(style);
  }

  function ensureSmoothCloseButtonStyle() {
    if (document.getElementById("dyz-smooth-close-button-style")) return;

    var style = document.createElement("style");
    style.id = "dyz-smooth-close-button-style";
    style.textContent = [
      "@media only screen and (max-width: 991px) {",
      "  .dyz-mobile-menu-close {",
      "    will-change: top, transform, opacity !important;",
      "  }",
      "  .dyz-mobile-menu-close.dyz-close-position-prep {",
      "    opacity: 0 !important;",
      "    visibility: hidden !important;",
      "    pointer-events: none !important;",
      "    transition: none !important;",
      "  }",
      "  body.dyz-mobile-menu-opening .dyz-mobile-menu-close {",
      "    transition:",
      "      opacity 300ms cubic-bezier(0.16, 1, 0.3, 1),",
      "      transform 520ms cubic-bezier(0.16, 1, 0.3, 1),",
      "      visibility 0s linear 0s !important;",
      "  }",
      "  body.mobile-menu-open:not(.dyz-mobile-menu-opening) .dyz-mobile-menu-close {",
      "    transition:",
      "      top 220ms cubic-bezier(0.16, 1, 0.3, 1),",
      "      opacity 280ms cubic-bezier(0.16, 1, 0.3, 1),",
      "      transform 420ms cubic-bezier(0.16, 1, 0.3, 1),",
      "      visibility 0s linear 0s !important;",
      "  }",
      "  body.dyz-mobile-menu-closing:not(.mobile-menu-open) {",
      "    overflow: auto !important;",
      "    touch-action: auto !important;",
      "  }",
      "}"
    ].join("\n");

    document.head.appendChild(style);
  }

  function markDirectCollectionSubmenuLinks(drawer) {
    if (!drawer) return;

    ensureDirectCollectionLinkStyle();

    qsa(".offcanvas__sub_menu_item", drawer).forEach(function (link) {
      if (!isDirectCollectionSubmenuLink(link)) return;

      link.classList.add("dyz-direct-collection-link");
      link.setAttribute("data-dyz-direct-collection-link", "true");
    });
  }

  function escapeHTML(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getDrawer() {
    return qs(".offcanvas-header") || qs("#offcanvas-header") || qs("[data-offcanvas-header]") || qs(".offcanvas__header");
  }

  function getHeaderSection() {
    return qs("#shopify__header__section") || qs(".shopify-section-header") || qs(".shopify-section-group-header-group") || qs("header");
  }

  function getVisibleHeaderBottom() {
    var candidates = [
      "#shopify__header__section .header__inner",
      ".shopify-section-header .header__inner",
      "header .header__inner",
      "#shopify__header__section .header__sticky",
      ".shopify-section-header .header__sticky",
      "header .header__sticky",
      "#shopify__header__section",
      ".shopify-section-header",
      "header"
    ];

    var bestBottom = 0;

    candidates.forEach(function (selector) {
      var el = qs(selector);
      if (!el) return;

      var rect = el.getBoundingClientRect();
      var style = window.getComputedStyle(el);

      if (style.display === "none" || style.visibility === "hidden") return;
      if (rect.width <= 0 || rect.height <= 0) return;

      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        bestBottom = Math.max(bestBottom, Math.ceil(rect.bottom));
      }
    });

    if (bestBottom < 40) bestBottom = 58;
    if (bestBottom > 140) bestBottom = 96;

    return bestBottom;
  }

  function isMobileViewport() {
    return !window.matchMedia || window.matchMedia("(max-width: 991px)").matches;
  }

  function getMobileVisualViewportHeight() {
    if (window.visualViewport && window.visualViewport.height) {
      return Math.round(window.visualViewport.height);
    }

    return Math.round(window.innerHeight || document.documentElement.clientHeight || 0);
  }

  function getCustomPxValue(name, fallback) {
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(name);
    var parsed = parseFloat(value);

    return isNaN(parsed) ? fallback : parsed;
  }

  function setMobileViewportVar(target, height) {
    if (!target || !target.style) return;
    target.style.setProperty("--dyz-mobile-visual-vh", height + "px");
  }

  function updateMobileViewportMetrics() {
    if (!isMobileViewport()) return;

    var height = getMobileVisualViewportHeight();
    if (!height || height < 300) height = Math.round(window.innerHeight || 700);

    var drawer = getDrawer();
    var overlay = qs(".offcanvas-overlay");
    var closeButton = qs(".dyz-mobile-menu-close");
    var headerSection = getHeaderSection();

    setMobileViewportVar(document.documentElement, height);
    setMobileViewportVar(document.body, height);
    setMobileViewportVar(headerSection, height);
    setMobileViewportVar(drawer, height);
    setMobileViewportVar(overlay, height);

    if (!drawer || !closeButton) return;

    var isActive = drawer.classList.contains("open") ||
      drawer.classList.contains(DRAWER_OPENING_CLASS) ||
      drawer.classList.contains(DRAWER_CLOSING_CLASS) ||
      document.body.classList.contains(BODY_OPEN_CLASS) ||
      document.body.classList.contains(BODY_CLOSING_CLASS);

    if (!isActive) return;

    var panelRect = drawer.getBoundingClientRect ? drawer.getBoundingClientRect() : null;
    var panelHeight = drawer.offsetHeight || (panelRect ? panelRect.height : 0) || 0;
    var bottomGap = getCustomPxValue("--dyz-mobile-menu-panel-bottom-gap", 10);
    var closeSize = closeButton.offsetHeight || getCustomPxValue("--dyz-mobile-menu-close-size", 64);
    var closeGap = getCustomPxValue("--dyz-mobile-menu-close-panel-gap", 16);
    var headerBottom = getVisibleHeaderBottom();
    var panelTop = height - bottomGap - panelHeight;

    if (
      panelRect &&
      panelRect.height > 0 &&
      panelRect.top > 0 &&
      panelRect.top < height &&
      drawer.classList.contains("open") &&
      !drawer.classList.contains(DRAWER_OPENING_CLASS) &&
      !drawer.classList.contains(DRAWER_CLOSING_CLASS)
    ) {
      panelTop = panelRect.top;
    }

    var closeTop = panelTop - closeSize - closeGap;

    closeTop = Math.max(headerBottom + 12, closeTop);

    document.documentElement.style.setProperty("--dyz-mobile-menu-close-dynamic-top", Math.round(closeTop) + "px");
    document.body.style.setProperty("--dyz-mobile-menu-close-dynamic-top", Math.round(closeTop) + "px");
  }

  function scheduleMobileCloseButtonSync() {
    if (!isMobileViewport()) return;

    updateMobileViewportMetrics();

    window.requestAnimationFrame(function () {
      updateMobileViewportMetrics();

      window.requestAnimationFrame(function () {
        updateMobileViewportMetrics();
      });
    });

    window.setTimeout(updateMobileViewportMetrics, 80);
    window.setTimeout(updateMobileViewportMetrics, 180);
    window.setTimeout(updateMobileViewportMetrics, 320);
  }

  function updateMobileDrawerTopOffset() {
    if (window.matchMedia && !window.matchMedia("(max-width: 991px)").matches) return;

    var drawer = getDrawer();
    var overlay = qs(".offcanvas-overlay");
    var headerSection = getHeaderSection();
    var offset = getVisibleHeaderBottom();

    document.documentElement.style.setProperty("--dyz-mobile-drawer-top-offset", offset + "px");
    document.body.style.setProperty("--dyz-mobile-drawer-top-offset", offset + "px");

    if (headerSection) headerSection.style.setProperty("--dyz-mobile-drawer-top-offset", offset + "px");
    if (drawer) drawer.style.setProperty("--dyz-mobile-drawer-top-offset", offset + "px");
    if (overlay) overlay.style.setProperty("--dyz-mobile-drawer-top-offset", offset + "px");

    updateMobileViewportMetrics();
  }

  function ensureOverlay(drawer) {
    var overlay = qs(".offcanvas-overlay");

    if (!overlay && drawer && drawer.parentNode) {
      overlay = document.createElement("div");
      overlay.className = "offcanvas-overlay";
      drawer.parentNode.insertBefore(overlay, drawer.nextSibling);
    }

    return overlay;
  }

  function ensureCloseButton(drawer) {
    ensureSmoothCloseButtonStyle();

    var closeButton = qs(".dyz-mobile-menu-close");

    if (!closeButton) {
      closeButton = document.createElement("button");
      closeButton.type = "button";
      closeButton.className = "dyz-mobile-menu-close";
      closeButton.setAttribute("aria-label", "Close menu");
      closeButton.setAttribute("data-offcanvas-close", "");
      closeButton.innerHTML = '<span class="visually-hidden">Close menu</span>';

      if (drawer && drawer.parentNode) {
        drawer.parentNode.insertBefore(closeButton, drawer.nextSibling);
      } else {
        document.body.appendChild(closeButton);
      }
    }

    return closeButton;
  }

  function isDrawerOpen() {
    var drawer = getDrawer();
    return !!(drawer && drawer.classList.contains("open"));
  }

  function setMenuButtonsState(isOpen) {
    qsa(".header__actions_btn--menu, .mobile__menu_bar").forEach(function (button) {
      button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  function setDrawerAccessibilityState(drawer, isHidden) {
    if (!drawer) return;

    drawer.setAttribute("aria-hidden", isHidden ? "true" : "false");

    if (isHidden) {
      drawer.setAttribute("inert", "");
    } else {
      drawer.removeAttribute("inert");
    }
  }

  function resetDrawerToInitialState(drawer) {
    if (!drawer) return;

    closeSubPanel();

    qsa(".offcanvas__menu_li.dyz-submenu-expanded", drawer).forEach(function (li) {
      var submenu = getSubmenu(li);
      var toggle = getToggle(li);

      li.classList.remove("dyz-submenu-expanded");
      if (submenu) submenu.setAttribute("hidden", "hidden");
      if (toggle) {
        toggle.setAttribute("aria-expanded", "false");
        toggle.setAttribute("aria-label", "Open submenu");
      }
    });

    qsa(".offcanvas__sub_menu", drawer).forEach(function (submenu) {
      submenu.setAttribute("hidden", "hidden");
    });

    qsa(".offcanvas__sub_menu_toggle", drawer).forEach(function (toggle) {
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open submenu");
    });

    qsa(".offcanvas__sub_menu_item.dyz-submenu-item-active", drawer).forEach(function (item) {
      item.classList.remove("dyz-submenu-item-active");
      item.removeAttribute("aria-current");
    });

    qsa(".dyz-mobile-subpanel", drawer).forEach(function (panel) {
      panel.classList.remove("is-active");
      panel.innerHTML = "";
    });

    document.body.classList.remove(BODY_SUBPANEL_CLASS);
    drawer.classList.remove("dyz-menu-dragging");
    drawer.style.removeProperty("--dyz-mobile-menu-drag-y");

    var scrollable = getDrawerScrollable(drawer);
    if (scrollable) scrollable.scrollTop = 0;
    drawer.scrollTop = 0;
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    window.clearTimeout(drawerAnimationTimer);

    ensureOverlay(drawer);
    var closeButton = ensureCloseButton(drawer);
    if (closeButton) closeButton.classList.add("dyz-close-position-prep");
    enableDrawerDragEvents();

    setDrawerAccessibilityState(drawer, false);
    resetDrawerToInitialState(drawer);
    prepareMobileSubmenus(drawer);

    drawer.classList.remove(DRAWER_CLOSING_CLASS);
    drawer.classList.add(DRAWER_OPENING_CLASS);
    drawer.style.removeProperty("--dyz-mobile-menu-drag-y");

    document.body.classList.remove(BODY_CLOSING_CLASS);
    document.body.classList.add(BODY_OPENING_CLASS);

    updateMobileDrawerTopOffset();
    scheduleMobileCloseButtonSync();

    setMenuButtonsState(true);

    window.requestAnimationFrame(function () {
      updateMobileViewportMetrics();
      document.body.classList.add(BODY_OPEN_CLASS);
      drawer.classList.add("open");

      window.requestAnimationFrame(function () {
        updateMobileViewportMetrics();
        if (closeButton) closeButton.classList.remove("dyz-close-position-prep");
      });

      drawerAnimationTimer = window.setTimeout(function () {
        drawer.classList.remove(DRAWER_OPENING_CLASS);
        document.body.classList.remove(BODY_OPENING_CLASS);
        scheduleMobileCloseButtonSync();
      }, DRAWER_OPEN_ANIMATION_MS);
    });
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    window.clearTimeout(drawerAnimationTimer);

    closeSubPanel();
    blurDrawerActiveElement(drawer);

    drawer.classList.remove(DRAWER_OPENING_CLASS);
    drawer.classList.add(DRAWER_CLOSING_CLASS);
    drawer.classList.remove("dyz-menu-dragging");
    drawer.classList.remove("open");

    document.body.classList.remove(BODY_OPENING_CLASS);
    document.body.classList.remove(BODY_OPEN_CLASS);
    document.body.classList.add(BODY_CLOSING_CLASS);
    releasePageInteractionAfterDrawerClose();
    updateMobileViewportMetrics();

    setMenuButtonsState(false);

    drawerAnimationTimer = window.setTimeout(function () {
      drawer.classList.remove(DRAWER_CLOSING_CLASS);
      drawer.style.removeProperty("--dyz-mobile-menu-drag-y");
      var closeButton = qs(".dyz-mobile-menu-close");
      if (closeButton) closeButton.classList.remove("dyz-close-position-prep");
      document.body.classList.remove(BODY_CLOSING_CLASS);
      disableDrawerDragEvents();
      releasePageInteractionAfterDrawerClose();
      setDrawerAccessibilityState(drawer, true);
    }, DRAWER_CLOSE_ANIMATION_MS);
  }

  function getDirectChild(parent, selector) {
    if (!parent) return null;

    var children = Array.prototype.slice.call(parent.children);

    for (var i = 0; i < children.length; i++) {
      if (children[i].matches(selector)) return children[i];
    }

    return null;
  }

  function getTopMenuItem(li) {
    if (!li) return null;

    return getDirectChild(li, ".offcanvas__menu_item") || getDirectChild(li, "a") || getDirectChild(li, "button:not(.offcanvas__sub_menu_toggle)");
  }

  function getSubmenu(li) {
    if (!li) return null;

    return getDirectChild(li, ".offcanvas__sub_menu") || getDirectChild(li, "ul") || qs(":scope > .offcanvas__sub_menu", li);
  }

  function getToggle(li) {
    if (!li) return null;

    return getDirectChild(li, ".offcanvas__sub_menu_toggle") || qs(":scope > .offcanvas__sub_menu_toggle", li);
  }

  function getMobileDefaultExpandFirstSetting() {
    var headerSection = getHeaderSection();
    if (!headerSection) return false;

    return headerSection.getAttribute("data-mobile-default-expand-first") === "true";
  }

  function applyDefaultExpandedSubmenu(drawer) {
    if (!drawer || !getMobileDefaultExpandFirstSetting()) return;

    var firstSubmenuItem = qsa(".offcanvas__menu_li.dyz-has-submenu", drawer)[0];
    if (!firstSubmenuItem) return;

    qsa(".offcanvas__menu_li.dyz-has-submenu", drawer).forEach(function (li) {
      var submenu = getSubmenu(li);
      var toggle = getToggle(li);
      var isFirst = li === firstSubmenuItem;

      li.classList.toggle("dyz-submenu-expanded", isFirst);

      if (submenu) {
        if (isFirst) submenu.removeAttribute("hidden");
        else submenu.setAttribute("hidden", "hidden");
      }

      if (toggle) {
        toggle.setAttribute("aria-expanded", isFirst ? "true" : "false");
        toggle.setAttribute("aria-label", isFirst ? "Close submenu" : "Open submenu");
      }
    });
  }

  function disableParentNavigation(menuItem) {
    if (!menuItem) return;

    if (menuItem.tagName && menuItem.tagName.toLowerCase() === "a") {
      var href = menuItem.getAttribute("href");

      if (isValidNavigableHref(href)) {
        menuItem.setAttribute("data-dyz-original-href", href);
      }

      menuItem.setAttribute("aria-haspopup", "true");
    }
  }

  function prepareMobileSubmenus(drawer) {
    if (!drawer) return;

    qsa(".offcanvas__menu_li", drawer).forEach(function (li) {
      var submenu = getSubmenu(li);
      var menuItem = getTopMenuItem(li);
      var toggle = getToggle(li);

      if (!submenu || !menuItem) return;

      li.classList.add("dyz-has-submenu");
      disableParentNavigation(menuItem);

      if (!toggle) {
        toggle = document.createElement("button");
        toggle.type = "button";
        toggle.className = "offcanvas__sub_menu_toggle";
        toggle.setAttribute("aria-label", "Open submenu");
        li.insertBefore(toggle, submenu);
      }

      if (!li.classList.contains("dyz-submenu-expanded")) {
        submenu.setAttribute("hidden", "hidden");
      }

      if (toggle) {
        var isExpanded = li.classList.contains("dyz-submenu-expanded");
        toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
        toggle.setAttribute("aria-label", isExpanded ? "Close submenu" : "Open submenu");
      }
    });

    markDirectCollectionSubmenuLinks(drawer);
    applyDefaultExpandedSubmenu(drawer);
  }

  function getDrawerScrollable(drawer) {
    return qs(".offcanvas__inner", drawer) || drawer;
  }

  function getClientY(event) {
    if (typeof event.clientY === "number") return event.clientY;
    if (event.touches && event.touches[0]) return event.touches[0].clientY;
    return 0;
  }

  function enableDrawerDragEvents() {
    if (dragEventsEnabled || !isMobileViewport()) return;

    dragEventsEnabled = true;
    document.addEventListener("pointerdown", beginDrag);
    document.addEventListener("pointermove", moveDrag, DRAG_MOVE_OPTIONS);
    document.addEventListener("pointerup", endDrag);
    document.addEventListener("pointercancel", endDrag);
  }

  function disableDrawerDragEvents() {
    if (!dragEventsEnabled) return;

    document.removeEventListener("pointerdown", beginDrag);
    document.removeEventListener("pointermove", moveDrag, DRAG_MOVE_OPTIONS);
    document.removeEventListener("pointerup", endDrag);
    document.removeEventListener("pointercancel", endDrag);
    dragEventsEnabled = false;
    dragState = null;
  }

  function blurDrawerActiveElement(drawer) {
    var active = document.activeElement;

    if (!active || active === document.body) return;

    try {
      if ((drawer && drawer.contains(active)) || active.closest && active.closest(".dyz-mobile-menu-close")) {
        active.blur();
      }
    } catch (error) {}
  }

  function releasePageInteractionAfterDrawerClose() {
    document.documentElement.style.removeProperty("overflow");
    document.documentElement.style.removeProperty("touch-action");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("touch-action");
  }

  function beginDrag(event) {
    var drawer = getDrawer();

    if (!drawer || !drawer.classList.contains("open") || !isMobileViewport()) return;
    if (event.target.closest("input, textarea, select")) return;

    var scrollable = getDrawerScrollable(drawer);

    dragState = {
      drawer: drawer,
      scrollable: scrollable,
      startY: getClientY(event),
      currentY: getClientY(event),
      dragging: false
    };
  }

  function moveDrag(event) {
    if (!dragState) return;

    var currentY = getClientY(event);
    var deltaY = Math.max(0, currentY - dragState.startY);

    dragState.currentY = currentY;

    if (deltaY <= 0) return;
    if (dragState.scrollable && dragState.scrollable.scrollTop > 0 && !dragState.dragging) return;

    if (deltaY > 6) {
      dragState.dragging = true;
      dragState.drawer.classList.add("dyz-menu-dragging");
    }

    if (!dragState.dragging) return;

    event.preventDefault();
    dragState.drawer.style.setProperty("--dyz-mobile-menu-drag-y", Math.round(deltaY) + "px");
  }

  function endDrag() {
    if (!dragState) return;

    var drawer = dragState.drawer;
    var deltaY = Math.max(0, dragState.currentY - dragState.startY);
    var shouldClose = dragState.dragging && deltaY > 86;

    drawer.classList.remove("dyz-menu-dragging");
    dragState = null;

    if (shouldClose) {
      closeDrawer();
      return;
    }

    drawer.style.setProperty("--dyz-mobile-menu-drag-y", "0px");
    scheduleMobileCloseButtonSync();

    window.setTimeout(function () {
      if (drawer.classList.contains("open")) {
        drawer.style.removeProperty("--dyz-mobile-menu-drag-y");
      }
    }, 260);
  }

  function toggleInlineSubmenu(li) {
    var drawer = getDrawer();
    if (!drawer || !li) return;

    var submenu = getSubmenu(li);
    var toggle = getToggle(li);

    if (!submenu) return;

    var willOpen = !li.classList.contains("dyz-submenu-expanded");

    qsa(".offcanvas__menu_li.dyz-submenu-expanded", drawer).forEach(function (item) {
      if (item !== li) {
        item.classList.remove("dyz-submenu-expanded");

        var itemSubmenu = getSubmenu(item);
        var itemToggle = getToggle(item);

        if (itemSubmenu) itemSubmenu.setAttribute("hidden", "hidden");
        if (itemToggle) itemToggle.setAttribute("aria-expanded", "false");
      }
    });

    if (willOpen) {
      li.classList.add("dyz-submenu-expanded");
      submenu.removeAttribute("hidden");
      if (toggle) {
        toggle.setAttribute("aria-expanded", "true");
        toggle.setAttribute("aria-label", "Close submenu");
      }
    } else {
      li.classList.remove("dyz-submenu-expanded");
      submenu.setAttribute("hidden", "hidden");
      if (toggle) {
        toggle.setAttribute("aria-expanded", "false");
        toggle.setAttribute("aria-label", "Open submenu");
      }
    }

    scheduleMobileCloseButtonSync();
  }

  function closeSubPanel() {
    qsa(".dyz-mobile-subpanel.is-active").forEach(function (panel) {
      panel.classList.remove("is-active");
      panel.innerHTML = "";
    });

    document.body.classList.remove(BODY_SUBPANEL_CLASS);
    scheduleMobileCloseButtonSync();
  }

  function getPanel(inner) {
    var panel = qs(".dyz-mobile-subpanel", inner);

    if (!panel) {
      panel = document.createElement("div");
      panel.className = "dyz-mobile-subpanel";
      inner.appendChild(panel);
    }

    return panel;
  }

  function renderProductPanel(category) {
    var drawer = getDrawer();
    if (!drawer || !category) return;

    var inner = qs(".offcanvas__inner", drawer) || drawer;
    var panel = getPanel(inner);
    var preloadedProducts = getPreloadedProductsForCategory(category);

    panel.innerHTML =
      '<div class="dyz-mobile-subpanel__header">' +
      '<button type="button" class="dyz-mobile-subpanel__back" aria-label="Back"></button>' +
      '<div class="dyz-mobile-subpanel__title">' +
      escapeHTML(category.title || "Products") +
      "</div>" +
      "</div>" +
      '<div class="dyz-mobile-subpanel__body">' +
      (preloadedProducts ? buildProductListHTML(preloadedProducts.slice(0, 8)) : '<div class="dyz-mobile-panel-loading">Loading products...</div>') +
      "</div>";

    panel.classList.add("is-active");
    document.body.classList.add(BODY_SUBPANEL_CLASS);
    scheduleMobileCloseButtonSync();

    var backButton = qs(".dyz-mobile-subpanel__back", panel);

    if (backButton) {
      backButton.addEventListener("click", function (event) {
        event.preventDefault();
        closeSubPanel();
      });
    }

    if (preloadedProducts) return;

    getProductsForCategory(category).then(function (products) {
      var limitedProducts = products.slice(0, 8);

      enrichProductsWithPriceRanges(limitedProducts).then(function (finalProducts) {
        renderProductsIntoPanel(panel, finalProducts);
      });
    });
  }

  function renderProductsIntoPanel(panel, products) {
    var body = qs(".dyz-mobile-subpanel__body", panel);
    if (!body) return;

    body.innerHTML = buildProductListHTML(products);
    scheduleMobileCloseButtonSync();
  }

  function buildProductListHTML(products) {
    if (!products || products.length === 0) {
      return '<div class="dyz-mobile-panel-empty">No products found.</div>';
    }

    var bodyHTML = '<div class="dyz-mobile-product-list">';

    products.forEach(function (product) {
      bodyHTML +=
        '<a class="dyz-mobile-product-card" href="' +
        escapeHTML(product.url) +
        '">' +
        '<div class="dyz-mobile-product-card__image">' +
        '<img src="' +
        escapeHTML(product.image) +
        '" alt="' +
        escapeHTML(product.title) +
        '" loading="lazy">' +
        "</div>" +
        '<div class="dyz-mobile-product-card__content">' +
        '<div class="dyz-mobile-product-card__title">' +
        formatMobileProductTitleHTML(product.title) +
        "</div>" +
        '<div class="dyz-mobile-product-card__price">' +
        escapeHTML(product.price || "") +
        "</div>" +
        "</div>" +
        "</a>";
    });

    bodyHTML += "</div>";
    return bodyHTML;
  }

  function normalizeUrlKey(url) {
    if (!url) return "";

    try {
      var parsedUrl = new URL(url, window.location.origin);
      return parsedUrl.pathname.replace(/\/$/, "");
    } catch (error) {
      return String(url || "")
        .split("?")[0]
        .replace(window.location.origin, "")
        .replace(/\/$/, "");
    }
  }

  function getPreloadedMegaProductsMap() {
    if (preloadedMegaProductsCache) return preloadedMegaProductsCache;

    preloadedMegaProductsCache = {};

    var dataScript = qs("#dyz-mobile-mega-product-data");
    if (!dataScript) return preloadedMegaProductsCache;

    try {
      var rawData = JSON.parse(dataScript.textContent || "{}");

      Object.keys(rawData).forEach(function (key) {
        var normalizedKey = normalizeUrlKey(key);
        var item = rawData[key];

        if (!normalizedKey || !item || !item.products) return;

        preloadedMegaProductsCache[normalizedKey] = item.products;
      });
    } catch (error) {
      preloadedMegaProductsCache = {};
    }

    return preloadedMegaProductsCache;
  }

  function getPreloadedProductsForCategory(category) {
    if (!category || !category.url) return null;

    var map = getPreloadedMegaProductsMap();
    var key = normalizeUrlKey(category.url);
    var products = map[key];

    if (!products || products.length === 0) return null;

    return products;
  }

  function getProductsForCategory(category) {
    return fetchProductsFromCollection(category.url).then(function (products) {
      if (products && products.length > 0) return products.slice(0, 8);

      return collectProductsFromDesktopMega().slice(0, 8);
    });
  }

  function enrichProductsWithPriceRanges(products) {
    if (!products || products.length === 0) return Promise.resolve([]);

    return Promise.all(
      products.map(function (product) {
        return fetchProductPriceRange(product.url).then(function (priceRange) {
          if (priceRange) product.price = priceRange;
          return product;
        });
      })
    );
  }

  function fetchProductPriceRange(productUrl) {
    return new Promise(function (resolve) {
      var jsonUrl = getProductJsonUrl(productUrl);

      if (!jsonUrl) {
        resolve("");
        return;
      }

      fetch(jsonUrl, { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) {
            resolve("");
            return null;
          }

          return response.json();
        })
        .then(function (productData) {
          if (!productData || !productData.variants || !productData.variants.length) {
            resolve("");
            return;
          }

          var prices = [];

          productData.variants.forEach(function (variant) {
            if (variant && typeof variant.price === "number") prices.push(variant.price);
          });

          if (!prices.length) {
            resolve("");
            return;
          }

          var minPrice = Math.min.apply(Math, prices);
          var maxPrice = Math.max.apply(Math, prices);

          resolve(formatPriceRangeFromCents(minPrice, maxPrice));
        })
        .catch(function () {
          resolve("");
        });
    });
  }

  function getProductJsonUrl(productUrl) {
    if (!productUrl) return "";

    try {
      var url = new URL(productUrl, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);

      if (!match || !match[1]) return "";

      return window.location.origin + "/products/" + match[1] + ".js";
    } catch (error) {
      return "";
    }
  }

  function formatPriceRangeFromCents(minPrice, maxPrice) {
    var min = formatMoney(minPrice);
    var max = formatMoney(maxPrice);

    if (!min) return "";
    if (minPrice === maxPrice || !max) return "From " + min;

    return "From " + min + " – " + max;
  }

  function formatMoney(cents) {
    if (typeof cents !== "number" || isNaN(cents)) return "";

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      var format = "${{amount}}";

      if (window.theme && window.theme.moneyFormat) {
        format = window.theme.moneyFormat;
      } else if (window.theme && window.theme.money_format) {
        format = window.theme.money_format;
      } else if (window.moneyFormat) {
        format = window.moneyFormat;
      } else if (window.money_format) {
        format = window.money_format;
      }

      return stripHTML(window.Shopify.formatMoney(cents, format));
    }

    return "$" + (cents / 100).toFixed(2);
  }

  function stripHTML(html) {
    var div = document.createElement("div");
    div.innerHTML = html || "";
    return cleanText(div.textContent || div.innerText || "");
  }

  function fetchProductsFromCollection(url) {
    return new Promise(function (resolve) {
      if (!url || url === "#" || url.indexOf("javascript:") === 0) {
        resolve([]);
        return;
      }

      var finalUrl = url;

      if (finalUrl.indexOf(window.location.origin) !== 0 && finalUrl.indexOf("/") === 0) {
        finalUrl = window.location.origin + finalUrl;
      }

      fetch(finalUrl, { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) {
            resolve([]);
            return null;
          }

          return response.text();
        })
        .then(function (html) {
          if (!html) {
            resolve([]);
            return;
          }

          var doc = new DOMParser().parseFromString(html, "text/html");
          resolve(collectProductsFromDocument(doc));
        })
        .catch(function () {
          resolve([]);
        });
    });
  }

  function collectProductsFromDocument(doc) {
    var products = [];
    var used = {};
    var root = doc;
    var possibleScopes = [".product-grid", "#product-grid", ".collection", ".collection__product", ".collection-product", ".main-collection-product-grid", "main"];

    for (var i = 0; i < possibleScopes.length; i++) {
      var scope = qs(possibleScopes[i], doc);
      if (scope) {
        root = scope;
        break;
      }
    }

    qsa('a[href*="/products/"]', root).forEach(function (link) {
      var href = link.href || link.getAttribute("href") || "";
      if (!href) return;

      if (href.indexOf(window.location.origin) !== 0 && href.indexOf("/") === 0) {
        href = window.location.origin + href;
      }

      var cleanHref = href.split("?")[0];
      if (used[cleanHref]) return;

      var card = findProductCardWrapper(link);
      var image = getProductImage(card || link);
      var title = getProductTitle(card || link, link);
      var price = getProductPrice(card || link);

      if (!image || !title) return;

      used[cleanHref] = true;

      products.push({
        url: href,
        image: image,
        title: title,
        price: price
      });
    });

    return products;
  }

  function collectProductsFromDesktopMega() {
    var mega = qs(".header__mega_menu") || qs(".header__sub_menu");
    var products = [];
    var used = {};

    if (!mega) return products;

    qsa('a[href*="/products/"]', mega).forEach(function (link) {
      var href = link.href || link.getAttribute("href") || "";
      if (!href || used[href]) return;

      var card = findProductCardWrapper(link);
      var image = getProductImage(card || link);
      var title = getProductTitle(card || link, link);
      var price = getProductPrice(card || link);

      if (!image || !title) return;

      used[href] = true;

      products.push({
        url: href,
        image: image,
        title: title,
        price: price
      });
    });

    return products;
  }

  function findProductCardWrapper(link) {
    return (
      link.closest(".product-card") ||
      link.closest(".product__card") ||
      link.closest(".product-card-wrapper") ||
      link.closest(".card-wrapper") ||
      link.closest(".grid__item") ||
      link.closest(".swiper-slide") ||
      link.closest(".mega-menu__product") ||
      link.closest(".header__mega_product") ||
      link.closest(".mega__product") ||
      link.closest(".product__items") ||
      link.closest(".product-item") ||
      link.closest("li") ||
      link.parentElement
    );
  }

  function getProductImage(root) {
    if (!root) return "";

    var img = qs("img", root);
    if (!img) return "";

    var src = img.currentSrc || img.getAttribute("src") || img.getAttribute("data-src") || img.getAttribute("data-original") || "";

    if (!src) {
      var srcset = img.getAttribute("srcset") || img.getAttribute("data-srcset") || "";
      if (srcset) src = srcset.split(",")[0].trim().split(" ")[0];
    }

    if (src && src.indexOf("//") === 0) src = window.location.protocol + src;

    return src;
  }

  function getProductTitle(root, fallbackLink) {
    if (!root) return "";

    var selectors = [".product-card__title", ".product__card__title", ".card__heading", ".card-title", ".product-title", ".product__title", "[class*='product'][class*='title']", "[class*='title']", "h3", "h4"];

    for (var i = 0; i < selectors.length; i++) {
      var node = qs(selectors[i], root);
      if (!node) continue;

      var text = cleanProductTitle(node.textContent);
      if (text) return text;
    }

    if (fallbackLink) {
      var fallback = cleanProductTitle(fallbackLink.textContent);
      if (fallback) return fallback;
    }

    return "";
  }

  function cleanProductTitle(text) {
    return cleanText(text)
      .replace(/From\s+\$[\d,]+(\.\d{2})?/gi, "")
      .replace(/\$[\d,]+(\.\d{2})?/g, "")
      .replace(/Save\s+\d+%/gi, "")
      .replace(/\d+\s+Reviews?/gi, "")
      .replace(/Reviews?/gi, "")
      .trim();
  }

  function formatMobileProductTitleHTML(title) {
    return formatMobileProductTitleParts(title)
      .map(function (part) {
        return '<span class="dyz-mobile-product-card__title-line">' + escapeHTML(part) + "</span>";
      })
      .join("");
  }

  function formatMobileProductTitleParts(title) {
    var rawTitle = cleanProductTitle(title)
      .replace(/\s+/g, " ")
      .replace(/\s+Tiles$/i, "")
      .replace(/\s+Tile$/i, "")
      .trim();

    var match = rawTitle.match(/^(\d+(?:\.\d+)?\s*["”]?\s*x\s*\d+(?:\.\d+)?\s*["”]?\s+(?:Subway|Square|Rectangle))\s+(.+?)\s+(Peel\s+and\s+Stick\s+Backsplash)$/i);

    if (match) {
      return [normalizeDimensionLine(match[1]), toTitleStyle(match[2]), "Peel and Stick Backsplash Tile"];
    }

    var matchWithoutBacksplash = rawTitle.match(/^(\d+(?:\.\d+)?\s*["”]?\s*x\s*\d+(?:\.\d+)?\s*["”]?\s+(?:Subway|Square|Rectangle))\s+(.+?)\s+Peel\s+and\s+Stick/i);

    if (matchWithoutBacksplash) {
      return [normalizeDimensionLine(matchWithoutBacksplash[1]), toTitleStyle(matchWithoutBacksplash[2]), "Peel and Stick Backsplash Tile"];
    }

    var fallbackMatch = rawTitle.match(/^(\d+(?:\.\d+)?\s*["”]?\s*x\s*\d+(?:\.\d+)?\s*["”]?)(?:\s+)?(.+)$/i);

    if (fallbackMatch) {
      return [normalizeDimensionLine(fallbackMatch[1]), toTitleStyle(fallbackMatch[2])];
    }

    return [toTitleStyle(rawTitle)];
  }

  function normalizeDimensionLine(text) {
    return cleanText(text)
      .replace(/\s*["”]\s*/g, '" ')
      .replace(/\s+x\s+/i, " x ")
      .replace(/\bsubway\b/i, "Subway")
      .replace(/\bsquare\b/i, "Square")
      .replace(/\brectangle\b/i, "Rectangle")
      .trim();
  }

  function toTitleStyle(text) {
    var smallWords = { and: true, or: true, the: true, of: true, in: true, on: true, for: true, with: true };

    return cleanText(text)
      .toLowerCase()
      .split(" ")
      .map(function (word, index) {
        if (!word) return word;
        if (index > 0 && smallWords[word]) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  }

  function getProductPrice(root) {
    if (!root) return "";

    var priceSelectors = [".price", ".product-price", ".product__price", ".card-information", "[class*='price']"];

    for (var i = 0; i < priceSelectors.length; i++) {
      var node = qs(priceSelectors[i], root);
      if (!node) continue;

      var price = extractPrice(node.textContent);
      if (price) return price;
    }

    return extractPrice(root.textContent);
  }

  function extractPrice(text) {
    var value = cleanText(text);
    if (!value) return "";

    var fromMatch = value.match(/From\s+\$[\d,]+(\.\d{2})?/i);
    if (fromMatch && fromMatch[0]) return fromMatch[0].replace(/\s+/g, " ");

    var moneyMatch = value.match(/\$[\d,]+(\.\d{2})?/);
    if (moneyMatch && moneyMatch[0]) return "From " + moneyMatch[0];

    return "";
  }

  document.addEventListener(
    "click",
    function (event) {
      var drawer = getDrawer();
      var menuButton = event.target.closest(".header__actions_btn--menu, .mobile__menu_bar");
      var globalCloseButton = event.target.closest(".dyz-mobile-menu-close");

      if (menuButton && !(drawer && drawer.contains(menuButton))) {
        event.preventDefault();

        if (isDrawerOpen()) closeDrawer();
        else openDrawer();

        return;
      }

      if (globalCloseButton) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var overlay = event.target.closest(".offcanvas-overlay");

      if (overlay) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (!drawer || !drawer.contains(event.target)) return;

      var closeButton = event.target.closest(".offcanvas__close, .offcanvas__close_btn, .offcanvas-close, [data-offcanvas-close]");

      if (closeButton) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      var subMenuLink = event.target.closest(".offcanvas__sub_menu_item");

      if (subMenuLink && drawer.contains(subMenuLink)) {
        var subMenuTitle = cleanText(subMenuLink.textContent);
        var subMenuHref = subMenuLink.getAttribute("href") || "";
        var shouldOpenDirectly = isDirectCollectionSubmenuLink(subMenuLink);
        var clickedArrowArea = isSubmenuArrowAreaClick(event, subMenuLink);

        /*
          DiYoZone Mobile Submenu Behavior:
          - Text area click goes directly to the collection page.
          - Right arrow area click opens the product sub-panel.
          - "All Backsplash Tiles" always goes directly to its collection page.
        */
        if (shouldOpenDirectly || (!clickedArrowArea && isValidNavigableHref(subMenuHref))) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          navigateToHref(subMenuHref);
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        qsa(".offcanvas__sub_menu_item.dyz-submenu-item-active", drawer).forEach(function (item) {
          item.classList.remove("dyz-submenu-item-active");
          item.removeAttribute("aria-current");
        });

        subMenuLink.classList.add("dyz-submenu-item-active");
        subMenuLink.setAttribute("aria-current", "true");

        renderProductPanel({
          title: subMenuTitle,
          url: subMenuHref || "#"
        });

        return;
      }

      var li = event.target.closest(".offcanvas__menu_li");
      if (!li || !drawer.contains(li)) return;

      var submenu = getSubmenu(li);
      var menuItem = getTopMenuItem(li);
      var toggle = getToggle(li);

      if (!submenu || !menuItem) return;
      if (event.target.closest(".offcanvas__sub_menu")) return;

      var clickedMenuItem = event.target === menuItem || menuItem.contains(event.target);
      var clickedToggle = toggle && (event.target === toggle || toggle.contains(event.target));

      if (!clickedMenuItem && !clickedToggle) return;

      if (clickedMenuItem && !clickedToggle) {
        var originalHref = menuItem.getAttribute("data-dyz-original-href") || menuItem.getAttribute("href") || "";

        if (isValidNavigableHref(originalHref)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          navigateToHref(originalHref);
          return;
        }
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      toggleInlineSubmenu(li);
    },
    true
  );

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    if (document.body.classList.contains(BODY_SUBPANEL_CLASS)) {
      closeSubPanel();
      return;
    }

    if (isDrawerOpen()) closeDrawer();
  });

  window.addEventListener("resize", function () {
    if (isDrawerOpen()) {
      updateMobileDrawerTopOffset();
      enableDrawerDragEvents();
    } else {
      disableDrawerDragEvents();
    }
    scheduleMobileCloseButtonSync();
  });

  window.addEventListener("orientationchange", function () {
    if (isDrawerOpen()) {
      window.setTimeout(function () {
        updateMobileDrawerTopOffset();
        updateMobileViewportMetrics();
      }, 250);
    }
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", function () {
      window.requestAnimationFrame(function () {
        if (isDrawerOpen()) updateMobileDrawerTopOffset();
        scheduleMobileCloseButtonSync();
      });
    });

    window.visualViewport.addEventListener("scroll", function () {
      window.requestAnimationFrame(function () {
        if (isDrawerOpen()) scheduleMobileCloseButtonSync();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    var drawer = getDrawer();
    if (!drawer) return;

    ensureOverlay(drawer);
    ensureCloseButton(drawer);
    prepareMobileSubmenus(drawer);
    scheduleMobileCloseButtonSync();
    if (!drawer.classList.contains("open")) setDrawerAccessibilityState(drawer, true);
  });

  window.addEventListener("load", function () {
    var drawer = getDrawer();
    if (!drawer) return;

    ensureOverlay(drawer);
    ensureCloseButton(drawer);
    prepareMobileSubmenus(drawer);
    scheduleMobileCloseButtonSync();
    if (!drawer.classList.contains("open")) setDrawerAccessibilityState(drawer, true);
  });
})();